import { useState } from 'react';

// All project types; the default selection shows everything merged.
export const ALL_PROJECT_TYPES = ['single', 'bulk', 'listing_score', 'deal_tag', 'update_title'];

// Labels matching the header nav buttons, reused by section titles.
export const PROJECT_TYPE_LABELS = {
  single: 'Single Listing',
  bulk: 'Bulk Listing',
  listing_score: 'Listing Score',
  deal_tag: 'Deal Tag',
  update_title: 'Title Update',
};

// Exclusive project-type filters that replace the whole selection when active.
const EXCLUSIVE_TYPES = ['listing_score', 'deal_tag', 'update_title'];

// Empty selection is the default view: nothing highlighted, everything shown.
export const useProjectTypeFilter = (initialTypes = []) => {
  const [selectedProjectTypes, setSelectedProjectTypes] = useState(initialTypes);

  const toggleType = (type) => {
    if (selectedProjectTypes.some(t => EXCLUSIVE_TYPES.includes(t))) {
      setSelectedProjectTypes([type]);
      return;
    }
    if (selectedProjectTypes.includes(type)) {
      // Deselecting the last active type returns to the show-all default
      setSelectedProjectTypes(selectedProjectTypes.filter(t => t !== type));
    } else {
      setSelectedProjectTypes([...selectedProjectTypes, type]);
    }
  };

  const toggleSingleListing = () => toggleType('single');
  const toggleBulkListing = () => toggleType('bulk');

  const toggleExclusive = (type) => {
    setSelectedProjectTypes(selectedProjectTypes.includes(type) ? [] : [type]);
  };

  const toggleListingScore = () => toggleExclusive('listing_score');
  const toggleDealTag = () => toggleExclusive('deal_tag');
  const toggleUpdateTitle = () => toggleExclusive('update_title');

  return {
    selectedProjectTypes,
    setSelectedProjectTypes,
    toggleSingleListing,
    toggleBulkListing,
    toggleListingScore,
    toggleDealTag,
    toggleUpdateTitle
  };
};
